import { ShieldAlert } from "lucide-react";

const KIND_LABEL = { identity_shield: "Identity Shield", reputation_pulse: "Sovereign Pulse" };

export const SovereignAlertsPanel = ({ alerts }) => (
  <div className="rounded-lg border border-sovereign/40 bg-sovereign/5 p-6" data-testid="sovereign-alerts-panel">
    <div className="mb-1 flex items-center gap-2">
      <ShieldAlert className="h-4 w-4 text-sovereign" />
      <h2 className="font-heading text-xl font-bold text-white">Sovereign Alerts &mdash; Emergency Protocol Incidents</h2>
    </div>
    <p className="mb-4 text-xs text-slate-500">
      High-confidence deepfake detections and Sovereign Pulse reputation-crisis alerts that triggered legal-team and Admin SMS.
    </p>
    {alerts.length === 0 ? (
      <p className="text-sm text-slate-500" data-testid="sovereign-alerts-empty">No incidents detected.</p>
    ) : (
      <div className="space-y-2" data-testid="sovereign-alerts-list">
        {alerts.map((a) => (
          <div key={a.id} className="rounded-md border border-sovereign/30 bg-obsidian p-3" data-testid={`sovereign-alert-row-${a.id}`}>
            <div className="mb-1 flex items-center gap-2">
              <span className="rounded-full border border-sovereign/50 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-sovereign">
                {KIND_LABEL[a.kind] || "Identity Shield"}
              </span>
              <p className="text-sm font-semibold text-white">
                {a.executive_name || a.target_name} <span className="ml-2 text-xs text-sovereign">score {a.combined_score}/100</span>
              </p>
            </div>
            <p className="mt-1 text-xs text-slate-400">{a.narrative}</p>
            <p className="mt-1 text-xs text-slate-600">
              Legal SMS: {a.sms_legal} &middot; Legal Team SMS: {a.sms_legal_team} &middot; Admin SMS: {a.sms_admin} &middot; {a.created_at ? new Date(a.created_at).toLocaleString() : ""}
            </p>
          </div>
        ))}
      </div>
    )}
  </div>
);

